module.exports = {"tube":{"":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/tube.json
// module id = 916
// module chunks = 108